export default __webpack_public_path__ + "static/icon-age-3ad9c362889c48f1f393bbeb989795d2.svg";